<template>
	<module-field :bind="$props">
		<span class="input-box">
			<input type="text" v-model="inputVal" :placeholder="field.placeholder">
		</span>
	</module-field>
</template>

<script>
// import CrudField from '@/mixins/CrudField';
import CrudField from '@/mixins/CrudField';

export default {
	mixins: [ CrudField ],
};
</script>
